import { createFileRoute } from '@tanstack/react-router'
import { Pricing } from '@/features/pricing'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/pricing/')({
  beforeLoad: requireAdmin,
  component: Pricing,
})
